import * as React from "react";
import { Stack, Typography, StackProps, TypographyProps } from "@mui/material";

export interface MetadataListItemProps extends StackProps {
  title: string;
  children: React.ReactNode;
  titleProps?: TypographyProps;
  contentProps?: StackProps;
  spaced?: boolean;
}

const MetadataListItem: React.FC<MetadataListItemProps> = (props) => {
  const { title, children, titleProps, contentProps, spaced = false, ...otherProps } = props;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={3} {...otherProps}>
      <Typography fontWeight={500} color="text.secondary" flexShrink={0} {...(spaced && { flex: 1 })} {...titleProps}>
        {title}
      </Typography>
      {spaced ? (
        <Stack direction="row" alignItems="center" flex={1} {...contentProps}>
          {children}
        </Stack>
      ) : (
        children
      )}
    </Stack>
  );
};

export default MetadataListItem;
